import { LocalDate } from '../../../models';
import { DateWithTimezones } from '../../../../common';

export interface LatestNotification {
  reason: string;
  actualArrivalTime: DateWithTimezones | LocalDate | number;
}
